import { useState } from "react";
import DefaultComm from "./components/DefaultComm";
import TemplateComm from "./components/TemplateComm";
import ScheduledComm from "./components/ScheduledComm";
import { getMenuFeatures } from "../../../utils/media";
import React from "react";
import { FEATURE } from "../../../configs/modules";

export const CommunicationUtils = () => {
  const [currentTabIndex, setcurrentTabIndex] = useState(null);
  const [ITEMS, setItems] = useState([]);
  const [defaultActiveKey, setdefaultActiveKey] = useState(null);

  /**
   * TABS list should come from BE where all the tabs are defined to add more tabs
   * you can use the below eg
   *  ,{ param: "nonScheduled", default: true, key: "4", label: " Non Scheduled Popup" },
   */
  const TABS = [
    {
      param: "notifications",
      default: false,
      key: "1",
      label: "Notifications",
    },
    {
      param: "fullScreen",
      default: false,
      key: "2",
      label: "Full Screen Popup",
    },
    { param: "manage", default: true, key: "3", label: "Manage" },
  ];

  const commtypes = [
    { label: "SMS", value: "SMS", checked: true },
    { label: "Whatsapp", value: "WHATSAPP" },
    { label: "Buddy Push Notification", value: "APPNOTIFICATION" },
  ];

  const updateTab = (tab) => {
    if (tab) {
      setdefaultActiveKey(TABS.find((item) => item.param === tab).key);
      return tab;
    } else {
      const getDefault = TABS.find((item) => item.default === true);
      setdefaultActiveKey(TABS.find((item) => item.default === true).key);
      return getDefault.param;
    }
  };

  const handleTabChange = (e, setSearchParams) => {
    setSearchParams({ tab: TABS.find((item) => item.key === e).param });
    setdefaultActiveKey(e);
  };

  /**
   * Returns a React component based on the provided `item` and additional feature-related props.
   * add more tabs by adding to the map like
   * nonScheduled : (
   *         <SomeComponent {...rest}
   *     />
   *  )
   */
  const getChildren = (item, features, feat) => {
    const data = {
      notifications: <DefaultComm featureTypeList={features} />,
      fullScreen: (
        <TemplateComm
          featureTypeList={features}
          editHtml={feat?.has(FEATURE.EDITHTML)}
        />
      ),
      manage: (
        <ScheduledComm
          featureTypeList={features}
          editHtml={feat?.has(FEATURE.EDITHTML)}
          handleTabChange={handleTabChange}
        />
      ),
    };
    return data[item];
  };

  const itemsCreator = () => {
    const feat = new Set(getMenuFeatures("comm"));
    const features = commtypes.filter((type) => feat.has(type.value));
    if (features?.length > 0) {
      const items = TABS.map((item) => {
        return { ...item, children: getChildren(item.param, features, feat) };
      });
      setItems(items);
    } else {
      setItems([
        {
          key: "1",
          label: "Notifications",
          children: <DefaultComm featureTypeList={features} />,
        },
      ]);
    }
  };
  return {
    ITEMS,
    updateTab,
    itemsCreator,
    handleTabChange,
    defaultActiveKey,
  };
};
